import { render } from "./add_reply.vue?vue&type=template&id=f54a8244&scoped=true"
import script from "./add_reply.vue?vue&type=script&lang=js"
export * from "./add_reply.vue?vue&type=script&lang=js"

import "./add_reply.vue?vue&type=style&index=0&id=f54a8244&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54a8244"]])

export default __exports__